import { useEffect, useState } from "react";
import { isTestEnv } from "../../../globals";

// Branches the current trade-delay user is limited to (shown as a banner
// above the orders). Fetched once; a failure only hides the banner.
const useBranchContext = (execute, enabled) => {
  const [branchContext, setBranchContext] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    execute("GET", `${process.env.REACT_APP_BACKEND_BASE_URL}/api/tradeDelay/branches`)
      .then((res) => !cancelled && setBranchContext(res || null))
      .catch((err) => isTestEnv && console.warn("Trade delay: failed to load branch context", err));
    return () => {
      cancelled = true;
    };
  }, [enabled, execute]);

  return branchContext;
};

export default useBranchContext;
